export default __webpack_public_path__ + "static/media/cudi.b9585dc1.jpg";